export const MODAL_HEIGHT_PERCENTAGE = 0.874;
export const MODAL_NON_SCROLLABLE_CONTENT_HEIGHT_DEFAULT = 170;
export const MODAL_NON_SCROLLABLE_CONTENT_HEIGHT_CREW_MODAL = 198;
export const MODAL_NON_SCROLLABLE_CONTENT_HEIGHT_FIRE_MISSION_MODAL = 198;
export const CONTENT_HEIGHT_SINGLE_USER = 170;
export const CONTENT_HEIGHT_MULTIPLE_USERS = 202;
